import { Outlet } from "react-router-dom";

function AllTasksMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default AllTasksMain;